import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { LoginGate } from './components/LoginGate';
import { PortalShell } from './components/PortalShell';
import { Dashboard } from './pages/Dashboard';
import { ProjectDetail } from './pages/ProjectDetail';
import { isAuthed } from './api/client';

/**
 * Single route entry point for the Evidence Pack module.
 *
 * Mounted at /portal/evidence/* in App.js. Everything below this component
 * lives inside /features/evidence and can be lifted out into a standalone
 * app without touching the public marketing site.
 */
const EvidencePortal = () => {
  const [authed, setAuthed] = useState(isAuthed());

  // Re-check auth if sessionStorage is cleared in another tab.
  useEffect(() => {
    const handler = () => setAuthed(isAuthed());
    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
  }, []);

  if (!authed) {
    return (
      <>
        <LoginGate onAuthed={() => setAuthed(true)} />
        <Toaster theme="dark" />
      </>
    );
  }

  return (
    <>
      <PortalShell onSignOut={() => setAuthed(false)}>
        <Routes>
          <Route index element={<Dashboard />} />
          <Route path="projects/:projectId" element={<ProjectDetail />} />
          <Route path="*" element={<Navigate to="." replace />} />
        </Routes>
      </PortalShell>
      <Toaster theme="dark" />
    </>
  );
};

export default EvidencePortal;
